import React from "react";
//primereact
import { ProgressBar } from "primereact/progressbar";

const CardProgressProfile = (props) => {
  let colorLabel = "";
  let icon = "";
  switch (props.type.toLowerCase()) {
    case "corretor":
      colorLabel = "bg-purple-300";
      icon = "fa-solid fa-handshake";
      break;
    case "financeiro":
      colorLabel = "bg-green-300";
      icon = "fa-solid fa-dollar-sign";
      break;
    case "administrador":
      colorLabel = "bg-cyan-300";
      icon = "fa-solid fa-user-tie";
      break;
    case "imobiliária":
      colorLabel = "bg-yellow-400";
      icon = "fa-solid fa-house";
      break;
    default:
      colorLabel = "bg-success-300";
      icon = "fa-solid fa-user-tie";
      break;
  }

  return (
    <div className="col-xl-3 col-md-5" key={props.key}>
      <div
        className="card-profile bg-white p-3 h-100"
        style={{ borderRadius: "15px" }}
      >
        <div className="d-flex justify-content-center">
          <img
            className="profile-progress rounded-circle"
            src={props.image}
            alt="profile"
          />
        </div>
        <div className="text-center my-2">
          <h2>{props.name}</h2>
          <h5
            className={`text-secondary mx-auto text-white ${colorLabel} rounded-pill p-2`}
            style={{ width: "60%" }}
          >
            <i className={`${icon} mx-1`}></i>
            {props.type}
          </h5>
          <h6>{props.email}</h6>
          <h5 className="mt-3">Estastísticas nos treinamentos</h5>
        </div>
        <div className="row p-2 rounded">
          <div className="col-md-6 text-center mt-1">
            <h5 className="mx-3">Corretores</h5>
          </div>
          <div className="col-md-6 mt-1">
            <ProgressBar
              className="w-100 fw-bolder"
              color={
                props.valueBroker <= 50
                  ? "#FF3D32"
                  : props.valueBroker < 100
                  ? "#F2D066"
                  : "success"
              }
              style={{ height: "15px", fontSize: "11px" }}
              value={props.valueBroker}
            ></ProgressBar>
          </div>
          <div className="col-md-6 text-center mt-1">
            <h5 className="mx-3">Imobiliárias</h5>
          </div>
          <div className="col-md-6 mt-1">
            <ProgressBar
              className="w-100 fw-bolder"
              color={
                props.valueHousing <= 50
                  ? "#FF3D32"
                  : props.valueHousing < 100
                  ? "#F2D066"
                  : "success"
              }
              style={{ height: "15px", fontSize: "11px" }}
              value={props.valueHousing}
            ></ProgressBar>
          </div>
          <div className="col-md-6 text-center mt-1">
            <h5 className="mx-3">Financeiro</h5>
          </div>
          <div className="col-md-6 mt-1">
            <ProgressBar
              className="w-100 fw-bolder"
              color={
                props.valueFinance <= 50
                  ? "#FF3D32"
                  : props.valueFinance < 100
                  ? "#F2D066"
                  : "success"
              }
              style={{ height: "15px", fontSize: "11px" }}
              value={props.valueFinance}
            ></ProgressBar>
          </div>
          <div className="col-md-6 text-center mt-1">
            <h5 className="mx-3">Administrador</h5>
          </div>
          <div className="col-md-6 mt-1">
            <ProgressBar
              className="w-100 fw-bolder"
              color={
                props.valueAdmin <= 50
                  ? "#FF3D32"
                  : props.valueAdmin < 100
                  ? "#F2D066"
                  : "success"
              }
              style={{ height: "15px", fontSize: "11px" }}
              value={props.valueAdmin}
            ></ProgressBar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardProgressProfile;
